export default "__VITE_ASSET__790e9165__"